---
title: Harborfront Pied-à-Terre
year: 2025
typology: residential
location: Cape Canaveral, FL
summary: A second residence for a couple who race in the harbor every spring. Two bedrooms, a galley kitchen, and a single long window facing the water.
heroImage: /projects/harborfront-pied-a-terre/hero.svg
heroAlt: A small harbor-facing living room with deep window seat, blue-grey plaster walls, and a single hanging brass pendant.
materials:
  - Blue-grey lime plaster
  - Solid teak
  - Antique brass
  - Hand-woven sisal
gallery:
  - src: /projects/harborfront-pied-a-terre/gallery/01.svg
    alt: View of the harbor through the long single window, distant sails on the water.
    caption: The view — pulled from a clouded morning over the harbor, color-matched into the plaster.
  - src: /projects/harborfront-pied-a-terre/gallery/02.svg
    alt: Solid teak floor with end-grain detail running through the room.
    caption: Teak underfoot, throughout. End-grain in the entry, plank elsewhere — the floor is the warmth in the room.
  - src: /projects/harborfront-pied-a-terre/gallery/03.svg
    alt: Brass pendant on a long cord, hanging over the small dining table.
    caption: The pendant — solid brass, hand-pulled, on a long cord. The only fixture in the kitchen.
  - src: /projects/harborfront-pied-a-terre/gallery/04.svg
    alt: Long window seat with waxed-canvas cushions overlooking the harbor.
    caption: The window seat — deeper than it needs to be, upholstered in waxed canvas. Sleeps two guests if the weather turns.
  - src: /projects/harborfront-pied-a-terre/gallery/05.svg
    alt: Reading chair beside the window with the harbor view beyond.
    caption: The reading chair — placed for the morning light, not for the conversation. One person at a time.
placeholder: true
---

A residence with no closets, by request.

Our clients wanted somewhere they could arrive with a duffel bag and leave the next morning. We treated the project as a study in **subtraction**: what is the smallest set of objects and surfaces required to live well for two nights at a time?

## What's there

Solid teak floors, throughout. Lime plaster in a blue-grey color we pulled from a clouded morning over the harbor. A deep window seat upholstered in waxed canvas. A single brass pendant in the kitchen, on a long cord.

A bed. A reading chair. A small dining table that doubles as a desk.

## What's not there

A television. A clothes closet. A guest room.

*Project complete. Photography forthcoming.*
